// External Libraries
import React from 'react';
import moment from 'moment';
import TimerIcon from '@mui/icons-material/Timer';
import TimerOffIcon from '@mui/icons-material/TimerOff';
import { timeConverter } from 'utils/helpers';
import { getStatusIcon } from 'utils/mappers';
import NoDataMsg from 'library/noData';


const Body = (props) => (
    <React.Fragment>
        {/* Table to display each day of the Date Range Selected */}
        {
            props.employees.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                props.employees.length > 0 ?
                    <div>
                        <div className="price_info">
                            <div className="list_header text-center">

                                <h6 className="m-0 p-0 text-white">{"Time Sheet"}</h6>
                            </div>
                            {
                                props.employees.map((item, index) => {
                                    var from = item.date;
                                    var validDate = moment(from, "YYYY/MM/DD").format('MMMM D, YYYY');

                                    return (
                                        <div className="row m-0 mb-2 border_bottom_grey mt-2 pb-2" key={index}>
                                            <div className="d-flex col-lg-4 col-md-2 col-sm-2 col-xs-12 pl-2 pr-1 center_xs">
                                                <div className="col-lg-8 center_xs pr-3">
                                                    <h6 className="bold size_1-25rem word-wrap">{item.employeeName}</h6>
                                                </div>
                                                <div className="col-lg-4 center_xs d-flex a-items">
                                                    <h6 className="size_1-2rem">{validDate}</h6>
                                                </div>
                                            </div>
                                            <div className="d-flex a-items col-lg-4 col-md-5 col-sm-5 col-xs-12 m-0 p-0 ">
                                                {/* START TIME */}
                                                <div className="row col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                                    <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 m-0 p-0 text-right pr-2">
                                                        <span className="table_icon"><TimerIcon /></span>
                                                    </div>
                                                    <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 m-0 p-0">
                                                        <label className="size_1-2rem">Start</label>
                                                        <h6 className="m-0 green-text size_1-2rem">{item.startShift}</h6>
                                                    </div>
                                                </div>
                                                {/* END TIME */}
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 m-0 p-0">
                                                    <div className="row m-0">
                                                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 m-0 p-0 text-right pr-2">
                                                            <span className="table_icon"><TimerOffIcon /></span>
                                                        </div>
                                                        <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 m-0 p-0">
                                                            <label className="size_1-2rem">End</label>
                                                            <h6 className="m-0 danger size_1-2rem">{item.endShift}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex a-items col-lg-4 col-md-5 col-sm-5 col-xs-12 m-0 p-0 col-4-p-0">
                                                {/* BREAK TIME */}
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0 center_xs">
                                                    <label className="size_1-2rem">Paid Break</label>
                                                    <h6 className="m-0 size_1-2rem">{item.paidBreak == 0 ? "NO" : "YES"}</h6>
                                                </div>
                                                {/* TOTAL HOURS */}
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0 center_xs">
                                                    <label className="size_1-2rem">Total Hours</label>
                                                    <h6 className="m-0 size_1-2rem">{timeConverter(item.totalMinutes)}</h6>
                                                </div>
                                                {/* STATUS */}
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 m-0 p-0 center_xs">
                                                    <label className="size_1-2rem">Status</label>
                                                    <h6 className="m-0 icon_status">{getStatusIcon(item.status)}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div> : ''
        }
    </React.Fragment>
)

export default Body;